import React, { useState } from 'react';

function CheckInOut({ reservations, onCheckIn, onCheckOut, totalRooms = 20 }) {
  const [filter, setFilter] = useState('all'); // 'all', 'arrivals', 'departures'

  const today = new Date().toISOString().split('T')[0];

  const todayArrivals = reservations.filter(r => 
    r.check_in === today && r.status === 'confirmed'
  );

  const todayDepartures = reservations.filter(r => 
    r.check_out === today && r.status === 'checked_in'
  );

  const currentGuests = reservations.filter(r => r.status === 'checked_in');

  const getFilteredData = () => {
    switch (filter) {
      case 'arrivals':
        return { title: 'Arrivées du Jour', data: todayArrivals, type: 'arrival' };
      case 'departures':
        return { title: 'Départs du Jour', data: todayDepartures, type: 'departure' };
      case 'inhouse':
        return { title: 'Clients Présents', data: currentGuests, type: 'inhouse' };
      default:
        return { title: 'Toutes les Opérations', data: [...todayArrivals, ...todayDepartures], type: 'all' };
    }
  };

  const filteredData = getFilteredData();

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <h2>Check-in / Check-out</h2>
        
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <button 
            className={`btn btn-small ${filter === 'all' ? 'btn-primary' : 'btn-secondary'}`}
            onClick={() => setFilter('all')}
          >
            Tout ({todayArrivals.length + todayDepartures.length})
          </button>
          <button 
            className={`btn btn-small ${filter === 'arrivals' ? 'btn-primary' : 'btn-secondary'}`}
            onClick={() => setFilter('arrivals')}
          >
            Arrivées ({todayArrivals.length})
          </button>
          <button 
            className={`btn btn-small ${filter === 'departures' ? 'btn-primary' : 'btn-secondary'}`}
            onClick={() => setFilter('departures')}
          >
            Départs ({todayDepartures.length})
          </button>
          <button 
            className={`btn btn-small ${filter === 'inhouse' ? 'btn-primary' : 'btn-secondary'}`}
            onClick={() => setFilter('inhouse')}
          >
            Présents ({currentGuests.length})
          </button>
        </div>
      </div>

      {/* Statistiques rapides */}
      <div className="dashboard" style={{ marginBottom: '2rem' }}>
        <div className="stat-card">
          <h3>Arrivées Prévues</h3>
          <div className="value" style={{ color: '#28a745' }}>
            {todayArrivals.length}
          </div>
          <small>Check-ins du jour</small>
        </div>
        
        <div className="stat-card">
          <h3>Départs Prévus</h3>
          <div className="value" style={{ color: '#dc3545' }}>
            {todayDepartures.length}
          </div>
          <small>Check-outs du jour</small>
        </div>
        
        <div className="stat-card">
          <h3>Clients Présents</h3>
          <div className="value" style={{ color: '#17a2b8' }}>
            {currentGuests.length}
          </div>
          <small>In-house</small>
        </div>
        
        <div className="stat-card">
          <h3>Chambres Disponibles</h3>
          <div className="value" style={{ color: '#6c757d' }}>
            {totalRooms - currentGuests.length}
          </div>
          <small>Sur {totalRooms} chambres</small>
        </div>
      </div>

      <h3>{filteredData.title}</h3>

      {filteredData.data.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '2rem', color: '#666', background: 'white', borderRadius: '8px' }}>
          {filter === 'arrivals' && 'Aucune arrivée prévue aujourd\'hui'}
          {filter === 'departures' && 'Aucun départ prévu aujourd\'hui'}
          {filter === 'inhouse' && 'Aucun client actuellement présent'}
          {filter === 'all' && 'Aucune opération prévue aujourd\'hui'}
        </div>
      ) : (
        <div style={{ display: 'grid', gap: '1rem' }}>
          {filteredData.data.map(reservation => (
            <div 
              key={reservation.id}
              style={{
                background: 'white',
                padding: '1.5rem',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '0.5rem' }}>
                  <h4 style={{ margin: 0, color: '#333' }}>
                    {reservation.guest_name}
                  </h4>
                  <span style={{
                    background: filteredData.type === 'departure' || reservation.status === 'checked_in' ? '#dc3545' : '#28a745',
                    color: 'white',
                    padding: '0.25rem 0.5rem',
                    borderRadius: '4px',
                    fontSize: '0.8rem',
                    fontWeight: 'bold'
                  }}>
                    Chambre {reservation.room_number}
                  </span>
                </div>
                
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '0.5rem', fontSize: '0.9rem', color: '#666' }}>
                  <div>
                    <strong>Email:</strong> {reservation.guest_email || 'Non renseigné'}
                  </div>
                  <div>
                    <strong>Type:</strong> {reservation.room_type}
                  </div>
                  <div>
                    <strong>Arrivée:</strong> {new Date(reservation.check_in).toLocaleDateString()}
                  </div>
                  <div>
                    <strong>Départ:</strong> {new Date(reservation.check_out).toLocaleDateString()}
                  </div>
                  <div>
                    <strong>Montant:</strong> €{((reservation.total_amount || 0) + (reservation.extra_charges || 0)).toFixed(2)}
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', gap: '0.5rem', flexDirection: 'column' }}>
                {reservation.status === 'confirmed' && (
                  <button 
                    className="btn btn-success"
                    onClick={() => onCheckIn(reservation.id)}
                    style={{ minWidth: '120px' }}
                  >
                    ✅ Check-in
                  </button>
                )}
                
                {reservation.status === 'checked_in' && (
                  <button 
                    className="btn btn-danger"
                    onClick={() => onCheckOut(reservation.id)}
                    style={{ minWidth: '120px' }}
                  >
                    🚪 Check-out
                  </button>
                )}

                {filteredData.type === 'inhouse' && (
                  <div style={{ fontSize: '0.8rem', color: '#666', textAlign: 'center' }}>
                    Depuis le {new Date(reservation.check_in).toLocaleDateString()}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default CheckInOut;